import angular from 'angular';
import Dtm from 'cars-ng-tracking/lib/dtm';
import Als from 'cars-ng-tracking/lib/als';
import LatLong from 'cars-ng-tracking/lib/latlong';

export default angular.module('cars.tracking', [
    Dtm,
    Als,
    LatLong
])

    .name;
